import React from 'react';
import { useTranslation } from 'react-i18next';
import { usePageContent } from '../../../hooks/useContentful';
import { ContentfulMultilineText } from '../../Contentful';
import './FilmIntro.css';

const FilmIntro: React.FC = () => {
  const { t } = useTranslation();
  const { data: pageContentData } = usePageContent('film-collection');
  const pageContent = pageContentData?.[0]?.fields as any;
  
  return (
    <div className="film-intro-section" data-scroll-section="intro">
      <ContentfulMultilineText 
        content={pageContent?.introText} 
        fallback={t('pages/filmCollection:intro.text')}
        as="p"
      />
    </div>
  );
};

export default FilmIntro;